
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.22 33.964h-5.619c-2.18 0-3.96 1.772-3.96 3.942v5.595c0 2.17 1.78 3.943 3.96 3.943h5.62c2.179 0 3.959-1.772 3.959-3.943v-5.595c0-2.17-1.78-3.942-3.96-3.942zm2.46 9.537c0 1.354-1.1 2.45-2.46 2.45h-5.619a2.453 2.453 0 01-2.46-2.45v-5.595c0-1.354 1.1-2.449 2.46-2.449h5.62c1.36 0 2.459 1.095 2.459 2.45V43.5z"}}),_c('path',{attrs:{"d":"M17.41 36.94a3.775 3.775 0 00-3.779 3.764c0 2.07 1.7 3.763 3.78 3.763s3.78-1.693 3.78-3.763c0-2.071-1.7-3.764-3.78-3.764zm-.81 5.954c-.17-.06-.339-.14-.489-.239l3.25-3.236c.1.15.18.309.24.488l-3 2.987zm-1.379-1.374l3.01-2.997c.17.06.33.14.48.24l-3.25 3.235a2.14 2.14 0 01-.24-.478zm1.8-3.106l-1.92 1.911c.17-.985.94-1.752 1.92-1.911zm.79 4.59l1.9-1.892a2.334 2.334 0 01-1.9 1.892zM49.506 49.435L28.49 28.408 20.78 8.885c-.2-.508-.79-.756-1.299-.557a.99.99 0 00-.56 1.294l6.02 15.232-9.44-9.438a.999.999 0 00-1.41 0 .988.988 0 000 1.404L26.79 29.523l8.858 22.44a1.005 1.005 0 001.3.558.99.99 0 00.56-1.294l-7.169-18.16L48.097 50.83c.2.199.45.288.71.288.25 0 .51-.1.71-.288a.995.995 0 00-.01-1.394z"}})])
          )
        }
      }
    